import React from 'react';
import { Input } from 'bootstrap';
import { DisplayForAdmin } from 'shared/components/misc/displayForRole';
import s3 from 'shared/constants/s3';

/**
 * Event Photo Selector
 */
export default React.createClass({
  displayName: 'EventPhotoSelector',

  propTypes: {
    teamId: React.PropTypes.string.isRequired,
    eventId: React.PropTypes.string.isRequired,
    imgUri: React.PropTypes.string,
    displayPhotoSelector: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      imgUri: s3.defaultEventPhoto,
    };
  },

  getInitialState() {
    return {
      imageIsToLargeError: false,
    };
  },

  render() {
    let { displayPhotoSelector, imgUri } = this.props;
    let photoSelector = null;

    if (displayPhotoSelector) photoSelector = this._getPhotoSelector();

    return (
      <div>
        {this.state.imageIsToLargeError ? this.getErrorNode() : null}
        <div className="event-photo-upload">
          {photoSelector}
          <img src={imgUri} alt="event avatar" />
        </div>
      </div>
    );
  },

  _handlePhotoChange(e) {
    e.preventDefault();

    let file = e.target.files[0];

    if (file && file.size > 1048576) {
      this.setState({ imageIsToLargeError: true });
    } else {
      this.props.handlePhotoChange(e);
      this.setState({ imageIsToLargeError: false });
    }
  },

  getErrorNode() {
    return (
      <div className="photo-selector-error team">
        Image size must be less than 1MB
      </div>
    );
  },

  _getPhotoSelector() {
    let { teamId, eventId } = this.props;

    return (
      <div className="event-photo-selector">
        <DisplayForAdmin teamId={teamId} eventId={eventId}>
          <div className="btn-file-upload">
            <span>Upload</span>
            <Input
              className="input-upload"
              ref="photoInput"
              type="file"
              onChange={(e) => this._handlePhotoChange(e)}
            />
          </div>
        </DisplayForAdmin>
      </div>
    );
  },
});
